import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useCachedResource } from "../hooks/useCachedResource";
import { listAcctPerms, setAcctPerms } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { NeuCard } from "../components/neu/Neu";
import { ADMIN_ROLES } from "../utils/role";

const KEYS = ["acct_view", "acct_post", "acct_manage"];

export default function AcctPermsPage() {
  const { t } = useTranslation();
  const { data, reload: load } = useCachedResource("acct-perms", () => listAcctPerms().catch(() => []));
  const rows = data || [];

  const toggle = async (row, key) => {
    const next = row.acct_perms.includes(key)
      ? row.acct_perms.filter((p) => p !== key)
      : [...row.acct_perms, key];
    await setAcctPerms(row.id, next);
    toast.success(t("acct.permsSaved"));
    load();
  };

  return (
    <AcctShell titleKey="perms">
      <div className="grid gap-3" data-testid="acct-perms-list">
        {rows.map((row) => (
          <NeuCard key={row.id} className="flex flex-wrap items-center gap-3 p-4" data-testid={`perm-row-${row.id}`}>
            <div className="min-w-0">
              <p className="truncate text-sm font-bold">{row.name}</p>
              <p className="truncate font-mono text-[11px] text-muted-foreground">{row.email} · {row.role}</p>
            </div>
            <div className="ms-auto flex flex-wrap gap-2">
              {KEYS.map((key) => {
                const on = ADMIN_ROLES.includes(row.role) || row.acct_perms.includes(key);
                return (
                  <button
                    key={key}
                    type="button"
                    disabled={ADMIN_ROLES.includes(row.role)}
                    data-testid={`perm-${key}-${row.id}`}
                    onClick={() => toggle(row, key)}
                    className={`rounded-full border px-3 py-1.5 text-[11px] font-bold disabled:opacity-60 ${
                      on ? "border-success/50 text-success shadow-neu-in" : "border-border/60 text-muted-foreground shadow-neu-sm"
                    }`}
                  >
                    {t(`acct.perms.${key}`)}
                  </button>
                );
              })}
            </div>
          </NeuCard>
        ))}
      </div>
    </AcctShell>
  );
}
